import { render, staticRenderFns } from "./taskDetails.vue?vue&type=template&id=cb54aaca&scoped=true&"
import script from "./taskDetails.vue?vue&type=script&lang=js&"
export * from "./taskDetails.vue?vue&type=script&lang=js&"
import style0 from "./taskDetails.vue?vue&type=style&index=0&id=cb54aaca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb54aaca",
  null
  
)

export default component.exports